import { useState, useEffect } from "react";
import { fetchAuthedDocsPreview } from "utils/docs";
import { getJWT } from "utils/auth";
import isError from "lodash/isError";
import startCase from "lodash/startCase";
import compact from "lodash/compact";
import { useRouter } from "next/router";

export const useAuthedDocsPreview = ({ pathname }) => {
  const jwtVal = getJWT();

  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const makeRequest = async () => {
    setLoading(true);
    const result = await fetchAuthedDocsPreview({ pathname });
    /**
     * Note: most likely error would be token expired
     */
    if (!isError(result)) {
      setPreview(result);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (jwtVal) {
      makeRequest();
    }
  }, []);

  return {
    loading,
    preview
  };
};

/**
 * e.g.
 * - A path of http://localhost:3002/docs/payments/payment-links/create#payments_payment_links_create-payment_method_types
 * - Where the hash value is #payments_payment_links_create-payment_method_types
 * - Results in a title of "How to create a Payment Link via the API {and customize the} payment method types."
 * - A path of http://localhost:3002/docs/payments/checkouts/object#payments_checkouts_object-payment_method_types
 * - Results in a title of "All about the checkout object {and it's} payment method types"
 */
const getActionSuffix = (route) => {
  let suffix;
  if (/create/.test(route)) {
    suffix = `and customize the`;
  } else if (/object/.test(route)) {
    suffix = `and it's`;
  } else if (/list/.test(route)) {
    suffix = `, listed by`;
  } else if (/retrieve/.test(route)) {
    suffix = `, retrieved by`;
  }

  return suffix;
};

export const usePageProps = ({ navConfig, frontMatter }) => {
  const { asPath } = useRouter();

  let title = `${frontMatter.title} – PriceBlocs`;
  let description = frontMatter.summary;
  /**
   * If there is hash routing
   * Parse it and use it as an input to metadata
   */
  const routeParts = compact(asPath.split("#"));
  const hasHashPath = routeParts[1];
  if (hasHashPath) {
    const hasAttrFocus = compact(hasHashPath.split("-"))[1];
    if (hasAttrFocus) {
      const focusArea = hasAttrFocus.split(".").join(" > ");
      title = `${frontMatter.title} – ${startCase(focusArea)}`;
      description = `${frontMatter.summary.replace(/\./, "")} ${getActionSuffix(
        routeParts[0]
      )} ${focusArea.replace(/_/g, " ")}.`;
    }
  }

  return {
    navConfig: navConfig,
    title,
    description,
    image: `${frontMatter.image}`,
    date: new Date(frontMatter.publishedAt).toISOString(),
    type: "article"
  };
};
